import React, { Component } from 'react';
import './LessonBlock.module.scss';

/**
 * import components
 */
import Label from 'components/UI/Label/Label';

class LessonBlock extends Component {

    constructor() {
        super();

        this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.props.handleClick(this.props.index);
    }

    render() {

        var { lesson } = this.props;

        let levels = [];

        let slug = lesson.name.split(" ").join("-").toLowerCase();

        for(var i = 0; i< 5; i++) {
            levels.push(<div styleName={`level ${i < this.props.level ? 'closed' : ''}`}></div>);
        }

        return (
            <div styleName={'lesson-block'} style={{backgroundColor: this.props.color}} onClick={this.handleClick}>
                <div styleName='triangle'></div>
                <div styleName='left'>
                    <h4 styleName={'title'}>{lesson.name}</h4>
                    <div styleName={'level-wrapper'}>
                        <p>Level</p>

                        {levels}
                    </div>
                    <p styleName='duur'>{lesson.steps.length} stappen</p>
                    <div styleName={'label-wrapper'}>
                        {lesson.label1 && <Label text={lesson.label1} extraClass={lesson.label1.toLowerCase()} />}
                        {lesson.label2 && <Label text={lesson.label2} extraClass={lesson.label2.toLowerCase()} />}
                    </div>
                </div>
                <div styleName='right' style={{backgroundImage: `url(images/lessons/thumbnails/${slug}.svg)`}}>
                </div>
            </div>
        );  
    }
}

export default LessonBlock;


// WEBPACK FOOTER //
// ./resources/assets/components/UI/LessonBlock/LessonBlock.jsx